// extracted by mini-css-extract-plugin
export default {"container":"style_container__cEgjR","buttonContainer":"style_buttonContainer__762no","svgSize":"style_svgSize__zVM9x"};